import { render, staticRenderFns } from "./pinggubaogao.vue?vue&type=template&id=7870af1e&scoped=true&"
import script from "./pinggubaogao.vue?vue&type=script&lang=ts&"
export * from "./pinggubaogao.vue?vue&type=script&lang=ts&"
import style0 from "./pinggubaogao.vue?vue&type=style&index=0&id=7870af1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7870af1e",
  null
  
)

export default component.exports